import { useCopyDemoMutation } from '@carboncopyco/data';
import type { DemoOverlay, IDemo } from '@carboncopyco/types';
import { notify } from '@carboncopyco/ui';
import NiceModal, { useModal } from '@ebay/nice-modal-react';
import { CopyAssetModal } from '../../../CopyAssetModal';

interface CopyDemoModalWithFoldersProps {
  organizationId: string;
  demo: IDemo | DemoOverlay;
  goToCopiedDemo?: (
    demoId: number,
    workspaceId: string,
    folderId: string
  ) => void;
}

export const CopyDemoModalWithFolders = NiceModal.create(
  ({ organizationId, demo, goToCopiedDemo }: CopyDemoModalWithFoldersProps) => {
    const modal = useModal();
    const [copyDemo, { isLoading: isLoadingCopyDemo }] = useCopyDemoMutation();

    const demoFolderId = String(demo.folderId);
    const demoWorkspaceId = String(demo.workspaceId);

    return (
      <CopyAssetModal
        isLoading={isLoadingCopyDemo}
        close={modal.remove}
        origin={{
          id: demoFolderId,
          entity: demoFolderId === '0' ? 'workspace' : 'folder',
          workspaceId: demoWorkspaceId,
        }}
        onSubmit={({ assetName, folderId, workspaceId }) => {
          copyDemo({
            organizationId,
            id: Number(demo.id),
            targetWorkspaceId: workspaceId,
            folderId: folderId,
            demoName: assetName,
          })
            .unwrap()
            .then(({ id, workspaceId, folderId }) => {
              goToCopiedDemo?.(id, workspaceId, folderId);
              notify.success('Demo was copied successfully');
            })
            .catch(() => {
              notify.error('Failed to copy demo');
            })
            .finally(() => {
              modal.remove();
            });
        }}
      />
    );
  }
);
